jQuery($ => {
	const megaMenuCloseTime = 300;
	let megamenuCloseTimeout = null;
	let megamenuCloseTimeoutTarget = '';
	let currentlyOpenedMegaMenu = '';
	const $body = $(document.body);
	const $header = $('#header');

	$body.children('.mega-menu-overlay').on('click', function(){
		closeMegaMenu(currentlyOpenedMegaMenu);
	});

	$('.desktop-main-menu > ul > li > a').on('mouseenter focus', function () {
		const $li = $(this).closest('li');
		$li.addClass('hovered');
	}).on('mouseleave blur', function () {
		const $li = $(this).closest('li');
		$li.removeClass('hovered');
	}).on('click', function(e) {
		if ($(this).parent().hasClass('menu-item-has-children')) {
			e.preventDefault();
			const $li = $(this).closest('li');
			const slug = $li.data('slug');
			if (isMegaMenuOpen(slug)) {
				closeMegaMenu(slug);
			} else {
				openMegaMenu(slug);
			}
		}
	});

	function closeMegaMenu(slug, openingOther = false) {
		if (slug === undefined || slug === '') return;
		const $matchingMegaMenu = $header.find(`.mega-menu[data-slug="${slug}"]`);
		const $menuLink = $header.find(`li.menu-item[data-slug="${slug}"]`);
		if ($matchingMegaMenu.length && !$matchingMegaMenu.is(':animated')) {
			$matchingMegaMenu.stop().slideUp(megaMenuCloseTime, function () {
				$(this).find('.mega-menu-level-1 li.focused').removeClass('focused');
				$(this).find('.mega-menu-level-2 ul').hide();
				if (! openingOther) {
					currentlyOpenedMegaMenu = '';
				}
			});
			$header.removeClass('has-open-mega-menu');
			$body.removeClass('has-open-mega-menu');
			$menuLink.removeClass('opened').children('a').attr('aria-expanded', 'false');
		}
	}

	function openMegaMenu(slug) {
		// if (slug === undefined || slug === '') return;
		if (currentlyOpenedMegaMenu !== slug) {
			closeMegaMenu(currentlyOpenedMegaMenu, true);
		}
		if (megamenuCloseTimeoutTarget === slug) {
			clearTimeout(megamenuCloseTimeout);
			megamenuCloseTimeoutTarget = '';
		}
		const $matchingMegaMenu = $header.find(`.mega-menu[data-slug="${slug}"]`);
		const $menuLink = $header.find(`li.menu-item[data-slug="${slug}"]`);
		if ($matchingMegaMenu.length) {
			$matchingMegaMenu.stop().slideDown(function () {
				$(this).css('height', 'auto');
			});
			currentlyOpenedMegaMenu = slug;
			$header.addClass('has-open-mega-menu');
			$body.addClass('has-open-mega-menu');
			$menuLink.addClass('opened').children('a').attr('aria-expanded', 'true').parent()
				.siblings().removeClass('opened').children('a').attr('aria-expanded', 'false');
		}
	}

	function isMegaMenuOpen(slug) {
		return currentlyOpenedMegaMenu === slug;
	}

	/* header desktop search */
	$header.find('.search-opener').click(function (e) {
		e.preventDefault();
		$('#desktopSearchPopup').slideDown(function () {
			$(this).find('input').focus();
		});
		$(this).attr('aria-expanded', 'true');
		$header.addClass('has-open-search').removeClass('has-open-secondary-menu has-open-language-menu');
		$('#desktopSecondaryMenuPopup, #desktopLanguageMenuPopup').slideUp();
	});
	$header.find('.search-close').click(function (e) {
		e.preventDefault();
		$('#desktopSearchPopup').slideUp(function () {
			$header.find('.search-opener').focus().attr('aria-expanded', 'false');
		});
		$header.removeClass('has-open-search');
	});

	/* header desktop secondary menu */
	$header.find('.menu-opener')
		.click(function (e) {
			e.preventDefault();
			$('#desktopSecondaryMenuPopup').slideToggle();
			$header.toggleClass('has-open-secondary-menu').removeClass('has-open-search has-open-language-menu');
			$('#desktopSearchPopup, #desktopLanguageMenuPopup').slideUp();
			$(this).attr('aria-expanded', $header.hasClass('has-open-secondary-menu') ? 'true' : 'false');
		})
		.on('keydown', function (e) {
			if (e.key === 'Tab' && ! e.shiftKey) {
				const $firstMenuElement = $('#desktopSecondaryMenuPopup li > a').first();
				if ($header.hasClass('has-open-secondary-menu') && $firstMenuElement.length) {
					$firstMenuElement.focus();
					e.preventDefault();
				}
			}
		});

	$('#desktopSecondaryMenuPopup li > a')
		.last()
		.on('keydown', function(e) {
			if (e.key === 'Tab' && ! e.shiftKey) {
				e.preventDefault();
				$header.find('.language-menu-opener').focus();
			}
		})
		.end()
		.first()
		.on('keydown', function(e) {
			if (e.key === 'Tab' && e.shiftKey) {
				e.preventDefault();
				$header.find('.menu-opener').focus();
			}
		});

	$header.find('.language-menu-opener')
		.on('keydown', function(e) {
			if (e.key === 'Tab' && e.shiftKey) {
				const $lastMenuElement = $('#desktopSecondaryMenuPopup li > a').last();
				if ($header.hasClass('has-open-secondary-menu') && $lastMenuElement.length) {
					e.preventDefault();
					$lastMenuElement.focus();
				}
			}
			if (e.key === 'Tab' && ! e.shiftKey && $header.hasClass('has-open-secondary-menu')) {
				// we have to skip the opened secondary menu to prevent a loop
				$('#desktopSecondaryMenuPopup li > a').last().focus();
				// no e.preventDefault() needed!
			}
		});


	/* header desktop language menu */
	$header.find('.language-menu-opener').click(function (e) {
		e.preventDefault();
		$('#desktopLanguageMenuPopup').slideToggle();
		$header.toggleClass('has-open-language-menu').removeClass('has-open-search has-open-secondary-menu');
		$('#desktopSearchPopup, #desktopSecondaryMenuPopup').slideUp();
		$(this).attr('aria-expanded', $header.hasClass('has-open-language-menu') ? 'true' : 'false');
	});
});
